import type { Language } from "@/hooks/useLanguage";

export function pickLegalLocale(language: Language): Language {
  return language === "en" ? "en" : "cs";
}
